import { render, staticRenderFns } from "./paymentAddress.vue?vue&type=template&id=16c8bc01"
import script from "./paymentAddress.vue?vue&type=script&lang=js"
export * from "./paymentAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Field: require('/home/ubuntu/containers/hermes_eshop/components/core/field.vue').default,Countries: require('/home/ubuntu/containers/hermes_eshop/components/core/countries.vue').default})
